import React from 'react';
import { Container } from 'react-bootstrap';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function SelectBranch () {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <div>
            <Container>
                <p>Notes</p>
                <div className='row'>
                    <div className='col'>
                            <Link to='/Cs'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/cs.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text">Computer Science</p>
                                    </div>
                                </div>
                            </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Ai'>
                            <div className="card" style={{width: 298}}>
                                <img src="images/ai.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text">Artificial Intelligence</p>
                                    </div>
                            </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Me'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/me.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Mechanical Engineering</p>
                                </div>
                        </div>
                        </Link>
                    </div>
                    <div className='col'>
                    <Link to='/Ce'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/ce.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Civil Engineering</p>
                                </div>
                        </div>
                    </Link>
                    </div>
                </div>




                <div className='row'>
                    <div className='col'>
                        <Link to='/Ee'>
                                <div className="card" style={{width: 298}}>
                                  <img src="images/ee.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text"> Electrical Engineering</p>
                                    </div>
                                </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/Ec'>
                            <div className="card" style={{width: 298}}>
                                <img src="images/ec.jpg" className="card-img-top" alt="quicklearn"/>
                                    <div className="card-body">
                                        <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                        <br/>
                                        <p className="card-text"> Electrical & Communication </p>
                                    </div>
                            </div>
                        </Link>
                    </div>
                    <div className='col'>
                        <Link to='/It'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/it.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">IT</p>
                                </div>
                        </div>
                        </Link>
                    </div>
                    <div className='col'>
                    <Link to='/Others'>
                        <div className="card" style={{width: 298}}>
                            <img src="images/others.jpg" className="card-img-top" alt="quicklearn"/>
                                <div className="card-body">
                                    <span style={{float:'left', paddingLeft:'8px', fontSize:'13px', fontWeight:'700'}}>B-tech</span> 
                                    <br/>
                                    <p className="card-text">Others</p>
                                </div>
                        </div>
                    </Link>
                    </div>
                </div>
                <br/> <br/> <br/> <hr/>
                <Footer/>
            </Container>
        </div>
    );
}

export default SelectBranch;
